import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SelectLocationPageRoutingModule } from './select-location-routing.module';

import { SelectLocationPage } from './select-location.page';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import { AgmCoreModule } from '@agm/core';
import {MapsAPILoader} from '@agm/core';


@NgModule({
  imports: [
    CommonModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB0pYUlir5lQ_vxEGAFlFKsrrjWm50qMzY', libraries: ["places"]
    }) ,
    FormsModule,ReactiveFormsModule,
    IonicModule,
    MatButtonModule,MatFormFieldModule,MatAutocompleteModule,
    SelectLocationPageRoutingModule
  ],
  declarations: [SelectLocationPage]
})
export class SelectLocationPageModule {}
// AIzaSyAAUdYL0b87elsQ2ewuF2B6qDGH4yKTMaI // Website
// AIzaSyB0pYUlir5lQ_vxEGAFlFKsrrjWm50qMzY // Mobile